<template>
  <div id="home">
    <el-header height="115px">
      <div class="topbar">
        <div class="row">
          <div class="action-right">
            您好，
            <!-- <label v-show="islogin">
              <a href="">
                <span class="showname">{{ mobilephone }}</span>
              </a>
              <span class="split"></span>
              <a href="" @click.prevent="loginout">退出</a>
              <p
                class="phone"
                @mouseover="isshowapplet = true"
                @mouseout="isshowapplet = false"
              >小程序
                <img v-show="isshowapplet" src="./assets/img/qrcode.jpg" alt="">
              </p>
            </label> -->
            <label>
              请
              <a href="/login">登录</a>
              <span class="split"></span>
              <p
                class="phone"
                @mouseover="isshowapplet = true"
                @mouseout="isshowapplet = false"
              >小程序
              <img v-show="isshowapplet" src="./assets/img/qrcode.jpg" alt="">
              </p>
            </label>
          </div>
        </div>
      </div>
      <v-header :navindex="0"></v-header>
    </el-header>
    <el-main class="home">
      <div class="banner">
        <el-carousel height="400px" arrow="never">
          <el-carousel-item class="slide-01"></el-carousel-item>
        </el-carousel>
      </div>
      <div class="robot">
        <div class="row">
          <div class="content">
            <h3 class="title">智能咨询</h3>
            <p>集合智能咨询、智能机器人自动推荐法律知识，专业咨询师提供优质咨询服务。</p>
            <a :href="robot.baseURL" class="btn" target="_blank">
              <img src="./assets/img/robot.png" alt="" class="robot-pic">
              智能咨询
            </a>
          </div>
        </div>
      </div>
      <div class="service">
        <div class="row">
          <div class="header">
            <h3 class="title">仲裁服务</h3>
            <p>以“便捷、高效、智能、保密”为基本理念，以互联网技术为支撑，打通立案、交费、审理、送达等全流程在线服务</p>
          </div>
          <div class="list">
            <a class="card" href="/login">
              <img src="./assets/img/service_img01.png" alt="">
              <div class="card-content">
                <h3>在线庭审</h3>
                <span>专业、高效在线庭审</span>
              </div>
            </a>
            <a class="card" href="/login">
              <img src="./assets/img/service_img02.png" alt="">
              <div class="card-content">
                <h3>在线调解</h3>
                <span>专业的深度调解服务</span>
              </div>
            </a>
            <a class="card" target="_blank" href="https://testgzzcwww.odrcloud.cn/login">
              <img src="./assets/img/service_img03.png" alt="">
              <div class="card-content">
                <h3>异步庭审</h3>
                <span>进入异步庭审</span>
              </div>
            </a>
          </div>
        </div>
      </div>
      <div class="sec-banner">
        <img src="./assets/img/sec-banner.png" alt="">
      </div>
      <div class="source">
        <div class="row">
          <div class="content">
            <h3 class="title">服务资源</h3>
            <p>为您提供平台专业化、优秀仲裁员，便捷、快速联系 沟通解决劳动纠纷。</p>
            <a href="" class="btn">查看更多</a>
          </div>
          <div class="card-section">
            <div class="card">
              <div class="top">
                <div class="avatar">
                  <img src="./assets/img/male_pic.png" alt="">
                </div>
                <div class="desc">
                  <span class="name">邓力夫</span>
                  <span class="spec">特邀仲裁员</span>
                  <p>广州劳动仲裁院</p>
                </div>
              </div>
              <div class="bottm">擅长：劳动争议</div>
            </div>
            <div class="card">
              <div class="top">
                <div class="avatar">
                  <img src="./assets/img/male_pic.png" alt="">
                </div>
                <div class="desc">
                  <span class="name">邓力夫</span>
                  <span class="spec">特邀仲裁员</span>
                  <p>广州劳动仲裁院</p>
                </div>
              </div>
              <div class="bottm">擅长：劳动争议</div>
            </div>
            <div class="card">
              <div class="top">
                <div class="avatar">
                  <img src="./assets/img/male_pic.png" alt="">
                </div>
                <div class="desc">
                  <span class="name">邓力夫</span>
                  <span class="spec">特邀仲裁员</span>
                  <p>广州劳动仲裁院</p>
                </div>
              </div>
              <div class="bottm">擅长：劳动争议</div>
            </div>
            <div class="card">
              <div class="top">
                <div class="avatar">
                  <img src="./assets/img/male_pic.png" alt="">
                </div>
                <div class="desc">
                  <span class="name">邓力夫</span>
                  <span class="spec">特邀仲裁员</span>
                  <p>广州劳动仲裁院</p>
                </div>
              </div>
              <div class="bottm">擅长：劳动争议</div>
            </div>
          </div>
        </div>
      </div>
    </el-main>
    <el-footer class="footer" style="height:36px">
      <div class="row clearfix">
        <div class="left">
          <span>穗CP备 180376XX号-1</span>
          <a href="" class="beian" target="_blank">
            <img src="./assets/img/beian.png">穗公网安备 11010702001XXX
          </a>
        </div>
        <div class="right">&copy;2020 bjsjsadr.com 版权所有</div>
      </div>
    </el-footer>
  </div>
</template>

<script>
import header from '@/components/v-header.vue'
import robot from '@/config/robot'
export default {
  components: {
    'v-header': header
  },
  data () {
    return {
      robot: robot,
      isshowapplet: false
    }
  }
}
</script>

<style lang="scss" scope>
.el-header,
.el-main,
.el-footer {
  padding: 0;
}
#home {
  background: #fff;
}
.row {
  width: 1100px;
  margin: 0 auto;
  position: relative;
}
.left {
  float: left;
}
.right {
  float: right;
}
.el-header {
  .topbar {
    background-color: #ececec;
    height: 36px;
    line-height: 36px;
    .action-right {
      float: right;
      font-size: 18px;
      color: #888;
      a {
        color: #888;
        padding: 0 5px;
      }
      .split {
        width: 1px;
        height: 9px;
        background-color: #ccc;
        display: inline-block;
      }
      .phone {
        padding: 0 5px;
        cursor: pointer;
        display: inline-block;
        position: relative;
        img {
          position: absolute;
          right: -30px;
          top: 28px;
          background-color: #fff;
          padding: 0;
          z-index: 2002;
          width: 110px;
          height: 110px;
          padding: 10px;
          border: 1px solid #e6e6e6;
          border-radius: 4px;
        }
        .iconfont {
          font-size: 16px;
          color: #a2a2a2;
          vertical-align: -2px;
        }
      }
    }
  }
}
.home {
  .title {
    display: inline-block;
    color: #1f73bf;
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 10px;
    &::after {
      content: '';
      display: block;
      margin-top: 4px;
      width: 20px;
      height: 3px;
      background: orange;
    }
  }
  .content {
    position: absolute;
    top: 36%;
    left: 0;
    p {
      color: #989898;
      font-size: 14px;
      line-height: 20px;
      width: 300px;
      margin-bottom: 20px;
    }
  }
  .btn {
    display: inline-block;
    padding: 6px 18px;
    background: #1f73bf;
    color: #fff;
    font-size: 14px;
    border-radius: 18px;
    box-shadow: 2px 4px 6px #e2edf7;
  }
  //
  .banner {
    width: 100%;
    position: relative;
    z-index: 5;
    .el-carousel {
      position: relative;
      img {
        position: absolute;
        left: 50%;
        width: 1920px;
        display: block;
        margin-left: -960px;
      }
      .slide-01 {
        background: url(./assets/img/banner.png) no-repeat center center;
        background-size: cover;
      }
    }
  }
  .robot {
    height: 500px;
    .row {
      height: 100%;
      background: url(./assets/img/bg_01.png) no-repeat right center/400px;
      position: relative;
      .robot-pic {
        width: 16px;
        height: 16px;
        vertical-align: -2px;
      }
    }
  }
  .service {
    // height: 500px;
    background: url(./assets/img/bg_02.png) no-repeat 50% #e7eff4;
    background-size: cover;
    padding-bottom: 50px;
    text-align: center;
    .header {
      padding: 60px 0 57px;
      .title::after {
        margin: 4px auto 0;
      }
      p {
        color: #989898;
        font-size: 14px;
      }
    }
    .list {
      display: flex;
      justify-content: center;
      .card {
        height: 266px;
        width: 20%;
        padding: 40px 20px 20px;
        margin-right: 70px;
        box-sizing: border-box;
        background: #fff;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        border-radius: 4px;
        img {
          width: 80px;
          height: 80px;
        }
        .card-content {
          margin-top: 30px;
          h3 {
            font-size: 20px;
            padding: 0 0 10px;
          }
          span {
            font-size: 12px;
            color: #989898;
          }
        }
      }
    }
  }
  .sec-banner {
    height: 300px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .source {
    height: 500px;
    background: url(./assets/img/bg_03.png) no-repeat bottom/100% 100px;
    .row {
      position: relative;
      height: 100%;
      .card-section {
        position: absolute;
        width: 700px;
        right: 0;
        top: 100px;
        .card {
          margin-right: 20px;
          margin-bottom: 20px;
          float: left;
          width: 300px;
          height: 140px;
          border-radius: 10px;
          box-shadow: 0 2px 12px 0 rgba(229, 241, 254, 0.5);
          padding: 20px 30px;
          box-sizing: border-box;
          .top {
            display: flex;
            border-bottom: 2px solid #e9e9e9;
            padding-bottom: 20px;
          }
          .avatar {
            width: 40px;
            height: 40px;
            margin-right: 20px;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .desc {
            font-size: 14px;
            .spec {
              display: inline-block;
              background: #1e6dcb;
              color: #fff;
              margin-left: 10px;
              border-radius: 10px;
              width: 86px;
              height: 22px;
              line-height: 22px;
              text-align: center;
            }
            p {
              margin-top: 4px;
              color: #aeaeae;
            }
          }
          .bottm {
            font-size: 13px;
            margin-top: 12px;
          }
        }
      }
    }
  }
}
.footer {
  // line-height: 36px;
  background-color: #0f0f10;
  color: #fff;
  height: 30px;
  line-height: 30px;
  font-size: 12px;
  a {
    color: #fff;
  }
  span {
    padding-right: 15px;
  }
  .beian {
    position: relative;
    padding-left: 28px;
    img {
      position: absolute;
      left: 8px;
      top: -2px;
    }
  }
}
</style>
